<template>
  <div class="loadings_box_pub" v-show="true">
      <div class="loadings bar">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="loadings_text_a">{{$t('PublicComponents.Loading.Loading')}}</div>
    </div>
</template>

<script>
export default {
  name:'loading'
}
</script>

<style lang="scss" scoped>
.loadings_box_pub {
    // margin-top: 10px;
    // margin-bottom: 20px;
    // padding-bottom: 20px;
align-items: center;
  display: flex;
  justify-content: center;
  .loadings {
  width: 60px;
  height: 60px;
//   margin: 0px auto;
  position: relative;
}
}
.loadings_text_a {
  margin-left: 40px;
display: flex;
align-items: center;
margin-top: 10px;
//   line-height: 90px;
  color: rgba(4,18,47,1);
  font-size: 16px;
  font-weight: 600
}

.dot {
    display: inline-block; 
    height: 1em;
    line-height: 1;
    text-align: left;
    vertical-align: -.25em;
    overflow: hidden;
}
.dot::before {
    display: block;
    content: '...\A..\A.';
    white-space: pre-wrap;
    animation: dot 1.3s infinite step-start both;
}
@keyframes dot {
    33% { transform: translateY(-2em); }
    66% { transform: translateY(-1em); }
}


.loadings.bar div {
  width: 13px;
  height: 0;
  // border-top: 36px solid #fff;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  //   width: 20px;
  //   height: 30px;
  //   background: #fff;
  position: absolute;
  top: 30px;
  left: 40px;
  //   opacity: 1;

//   -webkit-animation: fadeit 0.9s linear infinite;
  animation: fadeit 0.4s linear infinite;
}
.loadings.bar div:nth-child(1) {
  border-top: 20px solid rgba(245, 50, 51, 1);
  transform: rotate(0deg) translate(0, -30px);
  animation-delay: 0s;
}
.loadings.bar div:nth-child(2) {
  border-top: 20px solid rgba(233, 177, 60, 1);
  -webkit-transform: rotate(21deg) translate(0, -60px);
  transform: rotate(21deg) translate(0, -30px);
  animation-delay: 0.05s;
}
.loadings.bar div:nth-child(3) {
  border-top: 20px solid rgba(73, 165, 67, 1);
  transform: rotate(42deg) translate(0, -30px);
  animation-delay: 0.1s;
}
.loadings.bar div:nth-child(4) {
  border-top: 20px solid rgba(216, 42, 37, 1);
  transform: rotate(63deg) translate(0, -30px);
  animation-delay: 0.15s;
}
.loadings.bar div:nth-child(5) {
  border-top: 20px solid rgba(255, 66, 35, 1);
  transform: rotate(84deg) translate(0, -30px);
  animation-delay: 0.2s;
}
.loadings.bar div:nth-child(6) {
  border-top: 20px solid rgba(65, 201, 232, 1);
  transform: rotate(105deg) translate(0, -30px);
  animation-delay: 0.25s;
}
.loadings.bar div:nth-child(7) {
  border-top: 20px solid rgba(255, 193, 53, 1);
  transform: rotate(126deg) translate(0, -30px);
  animation-delay: 0.3s;
}
.loadings.bar div:nth-child(8) {
  border-top: 20px solid rgba(171, 35, 63, 1);
  transform: rotate(147deg) translate(0, -30px);
  animation-delay: 0.35s
}
.loadings.bar div:nth-child(9) {
  border-top: 20px solid rgba(255, 100, 41, 1);
  transform: rotate(168deg) translate(0, -30px);
  animation-delay: 0.4s;
}
.loadings.bar div:nth-child(10) {
  border-top: 20px solid rgba(237, 45, 105, 1);
  transform: rotate(189deg) translate(0, -30px);
  animation-delay: 0.45s;
}
.loadings.bar div:nth-child(11) {
  border-top: 20px solid rgba(255, 156, 50, 1);
  transform: rotate(210deg) translate(0, -30px);
  animation-delay: 0.5s;
}
.loadings.bar div:nth-child(12) {
  border-top: 20px solid rgba(208, 152, 49, 1);
  transform: rotate(231deg) translate(0, -30px);
  animation-delay: 0.55s;
}
.loadings.bar div:nth-child(13) {
  border-top: 20px solid rgba(60, 130, 67, 1);
  transform: rotate(252deg) translate(0, -30px);
  animation-delay: 0.6s;
}
.loadings.bar div:nth-child(14) {
  border-top: 20px solid rgba(46, 160, 217, 1);
  transform: rotate(273deg) translate(0, -30px);
  animation-delay: 0.65s;
}
.loadings.bar div:nth-child(15) {
  border-top: 20px solid rgba(92, 191, 73, 1);
  transform: rotate(294deg) translate(0, -30px);
  animation-delay: 0.7s;
}
.loadings.bar div:nth-child(16) {
  border-top: 20px solid rgba(20, 104, 163, 1);
  transform: rotate(315deg) translate(0, -30px);
  animation-delay: 0.75s;
}
.loadings.bar div:nth-child(17) {
  border-top: 20px solid rgba(22, 70, 108, 1);
  transform: rotate(336deg) translate(0, -30px);
  animation-delay: 0.8s;
}

@-webkit-keyframes fadeit {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeit {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>